import ExpandLessIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMoreRounded";
import { Collapse, Grid, IconButton, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { useState } from "react";

interface Props {
  title: string;
}

export const ExpandeGroup = ({ title, children }: PropsWithChildren<Props>) => {
  const [expanded, setExpanded] = useState(true);
  return (
    <Grid
      container
      sx={(theme) => ({ flex: 1, border: "1px solid " + theme.palette.divider, px: 1, width: "100%", borderRadius: 1 })}
    >
      <Grid container sx={{ alignItems: "center", width: "100%", justifyContent: "space-between" }}>
        <Typography variant="subtitle1">{title}</Typography>
        <IconButton onClick={() => setExpanded(!expanded)}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Grid>
      <Collapse orientation="vertical" in={expanded} sx={{ width: "100%" }}>
        <Grid container sx={{ py: 1, gap: 1, width: "100%" }}>
          {children}
        </Grid>
      </Collapse>
    </Grid>
  );
};

export default ExpandeGroup;
